<app-application-steps [currentStep]="4" [isDetailsView]="true" [showTechnicalFormFirst]="true"></app-application-steps>

<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!isLoading" class="component-container" id="print-form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'installation-data.reg-ep' | translate }}
      <span>- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId$ | async }}</span>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align" *ngIf="showTechnicalResource$ | async">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'regep.result.definition-of-system-design' | translate }}
    </div>
  </div>

  <ng-container *ngIf="applicationId$ | async as applicationId">
    <div class="ui-g-12 section">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <app-regep-technical-resource
          *ngIf="showTechnicalResource$ | async"
          [isReadOnly]="!(canEditTechnicalResource$ | async)"
          [applicationId]="applicationId"
          [orderProcess]="orderProcess$ | async"
          [showEnergyProducerIdInfoText]="showEnergyProducerIdInfoText"
          (formChange)="technicalResourcesForm = $event"></app-regep-technical-resource>
      </div>
    </div>

    <app-regep-order-process
      [applicationId]="applicationId"
      (executedProcessAction)="executedProcessAction($event, applicationId)"></app-regep-order-process>

    <app-order-history
      [applicationId]="applicationId"
      [pagination]="true"
      [useDefaultCls]="false"
      class="order-history"
      (formChange)="historyLogForm = $event"></app-order-history>

    <div class="ui-g-12 submit-button-section">
      <button
        type="button"
        (click)="exportCsv()"
        class="ui-button mr-3"
        icon="pi pi-download"
        label="{{ 'Export' | uppercase }}"
        pButton></button>
      <i class="pi pi-file-export"></i>
      <button
        type="button"
        (click)="router.navigate(['regep', 'documents', applicationId])"
        class="ui-button mr-3"
        label="{{ 'grid-comp.back' | translate | uppercase }}"
        pButton></button>
    </div>
  </ng-container>
</div>
